import axios from 'axios';
import { message } from 'antd'
import intl from 'react-intl-universal';
import exportExcel from '../utils/exportExcel'
export const login = (values) => {
    var that = this
    return (dispatch) => {
        axios({
            method: 'post',
            data: values,
            url: '/api/login'
        }).then((res) => {
            if (res.data.returnCode === 0) {
                message.success("success")
                sessionStorage.setItem('userName', res.data.name)
                sessionStorage.setItem('ifshowSnAdult', res.data.snAdultFlag)
                dispatch({
                    type: 'updateStatus'
                })
            } else if (res.data.returnCode === -1 || res.data.returnCode === 1) {
                //账号或密码错误
                message.error("username or password was wrong")
            }
        })
    }
}


export const initCategoryList = (userName, selectKey) => {
    return (dispatch) => {
        let url = "/api/getCategoryList?user=" + userName
        axios(url).then(res => {
            let data = res.data;
            //更新数据
            dispatch(initCaList(data, selectKey))
        })
    }
}

export const updataSelectKey = (id) => {
    return (dispatch) => {
        dispatch({
            type: 'updataSelectKey',
            data: {
                selectKey: id
            }
        })
    }
}

export const getChannelListByPage = (currentPage, pageSize, categoryid, userName, name) => {
    return (dispatch) => {
        let url = "/api/getChannelListByPage?pagesize=" + pageSize + "&currentPage=" + currentPage + "&categoryId=" + categoryid + "&user=" + userName;
        axios(url).then(res => {
            if (res.data.returnCode === 0) {
                let data = res.data
                dispatch(updateCurrentPage(currentPage))
                //更新数据
                dispatch(getChannelList(data))
                dispatch(updateCategoryIdAndName(categoryid, name))
            } else if (res.data.returnCode === 2) {
                dispatch(updateCurrentPage(1))
                //更新数据
                let data = {
                    channelList: [],
                    total: 0,
                    totalCount: 0
                }
                dispatch(getChannelList(data))
                dispatch(updateCategoryIdAndName(0, name))
            }
        })
    }
}

export const updateCurrentPage = (currentPage) => {
    return {
        type: 'updateCurrenPge',
        data: {
            currentPage: currentPage
        }
    }
}

export const updatePageSize = (pageSize) => {
    return {
        type: 'updatePageSize',
        data: {
            pageSize: pageSize
        }
    }
}

export const showAddModal = (action) => {
    let title = action === "add" ? intl.get("addCa") : intl.get("modifyCa");
    let flag = action === "add" ? 0 : 1
    return {
        type: 'showAddModal',
        data: {
            modalTitel: title,
            flag: flag
        }
    }
}

export const addCategory = (categoryName, userName, flag, cid, form) => {
    return (dispatch) => {
        let url = ""
        //flag === 0 添加状态
        //flag !== 0 修改状态
        if (flag === 0) {
            url = '/api/editCategory?cname=' + categoryName + '&action=1' + "&user=" + userName
        } else {
            url = '/api/editCategory?cname=' + categoryName + '&action=3' + "&user=" + userName + "&cid=" + cid
        }
        axios(url).then(res => {
            let returnCode = res.data.returnCode;
            if (returnCode === 0) {
                if (flag === 0) {
                    message.success(intl.get("addSuccess"))
                } else {
                    message.success(intl.get("modifySuccess"))
                }
                //更新categoryList
                if (flag === 0) {
                    cid = res.data.category.id
                }
                dispatch(initCategoryList(userName, cid))
                dispatch(updateCategoryIdAndName(cid, categoryName))
                dispatch(getChannelListByPage(1, 15, cid, userName, categoryName))
                dispatch({
                    type: 'hideModal'
                })
                form.resetFields();
            } else {
                message.error("category name already exists")
            }
        })
    }
}

export const hideModal = () => {
    return {
        type: 'hideModal'
    }
}

export const updateChannel = (row, categoryId, currentPage, pageSize, userName) => {
    return (dispatch) => {
        let params = {
            cid: categoryId,
            id: row.id,
            name: row.name,
            url: row.url,
            showNo: row.showNo,
            action: 3,
            user: userName
        }
        axios({
            dataType: 'json',
            headers: {
                "Content-Type": "application/json;charset=utf-8"
            },
            method: 'post',
            url: '/api/editChannel',
            data: JSON.stringify(params),
        }).then(res => {
            let returnCode = res.data.returnCode;
            if (returnCode === 0) {
                dispatch(getChannelListByPage(currentPage, pageSize, categoryId, userName))
            } else if (returnCode === 1) {
                message.error(intl.get("channelExist"));
            } else if (returnCode === 2) {
                message.error(res.data.msg)
            }
        })
    }
}

export const uploadExcel = (channels, categoryId, currentPage, pagesize, userName, initColumn, callback) => {
    return (dispatch) => {
        dispatch({
            type: 'showLoading'
        })
        let params = {
            //cid:categoryId,
            data: JSON.stringify(channels),
            user: userName
        }
        axios({
            dataType: 'json',
            headers: {
                "Content-Type": "application/json;charset=utf-8"
            },
            method: 'post',
            url: '/api/importExcel',
            data: JSON.stringify(params),
        }).then(res => {
            dispatch({
                type: 'hideLoading'
            })
            if (res.data.returnCode === 0) {
                dispatch(getChannelListByPage(currentPage, pagesize, categoryId, userName))
                dispatch(initCategoryList(userName, null))
                if (res.data.wrongList.length > 0) {
                    //导出表格
                    let total = channels.length
                    let successImport = channels.length - res.data.wrongList.length
                    let failImport = total - successImport
                    let duplicateChannelName = 0
                    let overLongChannelName = 0
                    let overLongCategoryName = 0
                    let urlFormatError = 0
                    exportWrongList(res.data.wrongList, initColumn)
                    for (let j = 0; j < res.data.wrongList.length; j++) {
                        if (res.data.wrongList[j].returnCode === -1) {
                            duplicateChannelName += 1
                        } else if (res.data.wrongList[j].returnCode === 2) {
                            overLongChannelName += 1
                        } else if (res.data.wrongList[j].returnCode === 4) {
                            urlFormatError += 1
                        } else if (res.data.wrongList[j].returnCode === 5) {
                            overLongCategoryName += 1
                        }
                    }
                    callback(total, successImport, failImport, duplicateChannelName, overLongChannelName, overLongCategoryName, urlFormatError);
                } else {
                    message.success("import successful")
                }
            } else if (res.data.returnCode === 1) {
                message.warning(intl.get("uploadTypeNotRight"))
            } else if (res.data.returnCode === 2) {
                message.error(intl.get("addCafir"))
            } else if (res.data.returnCode === 3) {
                message.error("there is none channel in the imported excel");
            } else if(res.data.returnCode === 6){
                message.error("Classification number greater than 20");
            }else if(res.data.returnCode === 7){
                message.error("The number of programs is more than 2000");
            }

            //更新当前选中的categoryId
            updataSelectKey(categoryId)
        })
    }
}

export const deleteCategory = (categoryid, userName, pageSize) => {
    return (dispatch) => {
        let url = '/api/editCategory?cid=' + categoryid + '&action=2' + "&user=" + userName
        axios(url).then(res => {
            let returnCode = res.data.returnCode;
            if (returnCode === 0) {
                message.success(intl.get("deleteSuccess"))
                //更新categoryList
                dispatch(initCategoryList(userName, null))
                //更新表格数据
                dispatch(getChannelListByPage(1, pageSize, 0, userName))
                dispatch(resetCategoryId())
            } else {
                message.error(intl.get("deleteFail"))
            }
        })
    }
}

export const addChannel = (name, url, cid, user, pageSize, from) => {
    return (dispatch) => {
        let params = {
            cid: cid,
            name: name,
            url: url,
            action: 1,
            user: user
        }
        axios({
            dataType: 'json',
            headers: {
                "Content-Type": "application/json;charset=utf-8"
            },
            method: 'post',
            url: '/api/editChannel',
            data: JSON.stringify(params),
        }).then(res => {
            let returnCode = res.data.returnCode;
            if (returnCode === 0) {
                dispatch(getChannelListByPage(1, pageSize, cid, user))
                //隐藏模态框
                dispatch(hideChannelModal())
                message.success(intl.get("addSuccess"))
                from.resetFields();
            } else if (returnCode === 1) {
                message.error(intl.get("operationFailed"))
            } else if (returnCode === 2) {
                message.error("please input right url")
            } else if (returnCode === 7) {
                message.error("The number of programs is more than 2000")
            }
            // else if (returnCode === -1) {
            //      message.error(res.data.msg)
            // }
            
        })
    }
}

export const showChannleModal = () => {
    return (dispatch) => {
        dispatch({
            type: 'showChannleModal'
        })
    }
}

export const hideChannelModal = () => {
    return (dispatch) => {
        dispatch({
            type: 'hideChannleModal'
        })
    }
}

export const updateSelectedData = (rows) => {
    return (dispatch) => {
        dispatch({
            type: "updateSelectedData",
            data: {
                selectedRows: rows
            }
        })
    }
}

export const batchDeleteChannels = (rows, pageSize, user, cid) => {
    return (dispatch) => {
        let ids = ""
        rows.forEach(function (value, index, array) {
            ids = ids + value.id + ","
        });
        let params = {
            ids: ids,
            cid: cid,
            user: user,
            action: 4
        }
        axios({
            dataType: 'json',
            headers: {
                "Content-Type": "application/json;charset=utf-8"
            },
            method: 'post',
            url: '/api/editChannel',
            data: JSON.stringify(params),
        }).then(res => {
            let returnCode = res.data.returnCode;
            if (returnCode === 0) {
                dispatch(getChannelListByPage(1, pageSize, cid, user))
                //清除当前选中
                dispatch(clearSelectedRows())
                message.success(intl.get("deleteSuccess"))
            } else if (returnCode === 1) {
                message.error(intl.get("operationFailed"))
            }
        })
    }
}

const initCaList = (data, selectKey) => {
    return {
        type: 'initCategoryList',
        data: {
            categoryList: data,
            selectKey: selectKey
        }
    }
}

const getChannelList = (data) => {
    return {
        type: 'getChannelList',
        data: {
            channelList: data.channels,
            total: data.total,
            totalCount: data.totalCount,
        }
    }
}

const updateCategoryIdAndName = (id, name) => {
    return {
        type: 'updateCategoryId',
        data: {
            categoryId: id,
            name: name
        }
    }
}

const clearSelectedRows = () => {
    return {
        type: 'clearSelectedRows',
    }
}

const resetCategoryId = () => {
    return {
        type: 'resetCategoryId'
    }
}

const exportWrongList = (wrongList, initColumn) => {
    exportExcel(initColumn, wrongList)
}


// 成人节目控制  0 : on 1 : off
export const adultControl = (user, flag) => {
    console.log("user: " + flag)
    return (dispatch) => {
        axios("api/adultControl?sn=" + user + "&flag=" + flag).then(res => {
            if (res.data === 0) {
                if(flag === 0){
                    message.success(intl.get("adult.trun.on.success"))
                }else{
                    message.success(intl.get("adult.trun.off.success"))
                }
                
            } else if (res.data === 1) {
                if(flag === 0){
                    message.success(intl.get("adult.trun.on.failure"))
                }else{
                    message.success(intl.get("adult.trun.off.failure"))
                }
            }
            dispatch(setAdultControl(flag));
        })
    }
}

export const initAdultControl =(user) =>{
    return(dispatch) =>{
         axios("api/getAdultControl?sn=" + user).then(res =>{
            dispatch(setAdultControl(res.data))
         })
    }
}

const setAdultControl = (value) => {
    return {
        type: 'setAdultControl',
        data:{
            adultControlValue : value
        }
    }
}



// WEBPACK FOOTER //
// ./src/service/ClientLinkCreator.js